import React from 'react';

type AdStatsProps = {
  title: string;
  secondtitle?: string;
  Icon: React.ElementType;
  children: React.ReactNode;
};

const AdStatsContainer: React.FC<AdStatsProps> = ({ title, secondtitle, Icon, children }) => {
  return (
    <section className="h-fit w-full">
      <div className="overflow-hidden border border-primary rounded-2xl bg-primary shadow-md p-3">
        <dt className="font-bold text-gray-200 p-2 flex items-center gap-2">
          <Icon className="text-white text-3xl" />
          <span className="flex lg:flex-row flex-col lg:gap-2 lg:items-center">
            <p className="text-lg uppercase">{title}</p>
            {secondtitle && <p className="text-md">{secondtitle}</p>}
          </span>
        </dt>
        {children}
      </div>
    </section>
  );
};

export default AdStatsContainer;
